import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import styles from './index.module.css'
import { transformString } from '../../../helpers/utils'
import { FilterData } from '../../../interfaces/course'


const CLOSE_IMAGE_URL = "https://members.performancegolf.com/wp-content/uploads/2025/04/close-circle.svg"
interface Props {
    isSidebarOpen:boolean,
    handleSidebarToggle: ()=> void
    selectedFilters: Record<string, string[]>
    onFilterChange: (filterType: string, category: string, isChecked: boolean) => void
    source?: string
    filterData: FilterData[];
    
}

function TrainingHeader({handleSidebarToggle,isSidebarOpen,selectedFilters,onFilterChange, source, filterData}:Props) {

  const [localFilterData, setLocalFilterData] = useState<FilterData[]>([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768));
  const allowedCourseTypes = ["irons", "driving", "bunkers", "chipping", "putting", "mental-game"];

  useEffect(() => {
    if (filterData.length > 0) {
      setLocalFilterData(filterData);
    }
  }, [filterData]);

  //count for filter number
  const courseTypeCount = useMemo(() => {
    return Object.values(selectedFilters).reduce((acc, arr) => acc + arr.length, 0);
  }, [selectedFilters]);
  
// console.log("this is filterData >>    ", filterData);

  return (
    <Box className="coursesMargin" 
    sx={{
      padding:source === "SC" && isMobile ? '0 !important' : 'none',
      ...(source === "SC" && {
        '@media (max-width: 767px)': {
          marginLeft: '0px !important'
        }
      })
    }}
    >
        <Box sx={{
          width:'100%',
          display:'flex', 
          flexDirection:source === "SC" ? 'column' : 'row', 
          gap:source === "SC" ? '20px' : '0',
          }}>
         <Typography className={ source === "SC" ? styles.titleSC : styles.title} style={{
          width:source === "SC" ? '100%' : '332px',
         }}>
            {source === "SC"? "What part of your game do you want to work on the most?":"TRAINING"}
         </Typography>

         {!isMobile && source === "SC" && <Box sx={{marginLeft:source === "SC" ? '0' : '0'}}>
         {Object.keys(selectedFilters).some(key => Array.isArray(selectedFilters[key]) && selectedFilters[key].length > 0) &&
         <Box sx={{display:'flex',flex:1,alignItems:'center'}}>
          <Typography color={'#000000'} fontSize={16} fontWeight={400} 
            sx={{
              textTransform: source === "SC" ? 'uppercase' : 'none',
              fontFamily: source === "SC" ? 'Repro Mono' : 'Repro',
              fontSize: source === "SC" ? '16px' : '16px',
              fontWeight: source === "SC" ? 400 : 400,   
              color: source === "SC" ? '#1D1A1A' : '#000000',           
            }}>Selected Filters</Typography>
          <Box sx={{display:'flex',flex:1,marginLeft:'17px',overflow:'auto'}}>
            <Box sx={{display:'flex',gap:'5px'}}>
              {Object.keys(selectedFilters).map((key,index)=>(
                selectedFilters[key].map((filter,index)=>(
                  <Box onClick={()=>{onFilterChange(key,filter,false)}} key={index} className={source ==="SC" ? styles.filterBoxOld: styles.filterBox}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4 10L15 6.4L13.6 5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#7B726C"/>
                    </svg>
                    <Typography     sx={{ whiteSpace: 'nowrap', marginLeft: source === "SC" ? '4px' : '0', textTransform: source === "SC" ? 'uppercase' : 'none' }}
                                    fontSize={14} fontWeight={400} color={source === "SC" ? '#444448' : '#000000'}>{transformString(filter)}</Typography>
                  </Box>
                ))
              ))}
              {/* <Box
                sx={{
                  maxHeight: '300px',
                  overflowX: 'auto',
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '12px',
                }}
              >
                {localFilterData
                .filter(filter => filter.filterType === "Course Type") // Only include "Course Type"
                .map(filter =>
                  filter.data.map(el => {
                    const isSelected = selectedFilters[filter.filterType]?.includes(el.category);
                    return (
                      <Box
                        onClick={() => onFilterChange(filter.filterType, el.category, isSelected ? false : true)}
                        key={`${filter.filterType}-${el.category}`}
                        className={styles.filterBox}
                        sx={{
                          padding: '12px',
                          backgroundColor: isSelected ? '#355ADD' : 'transparent',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexGrow: 1,
                          }}
                        >
                          <Typography
                            sx={{ whiteSpace: 'nowrap' }}
                            fontSize={16}
                            fontWeight={600}
                            color= {isSelected? "#fff" : "#000000"}
                            overflow= 'hidden'
                          >
                            {transformString(el.title)}
                          </Typography>
                          {isSelected && <img src={CLOSE_IMAGE_URL} alt="Remove Filter" />}
                        </Box>  
                      </Box>
                    );
                  })
                )}
              </Box> */}
            </Box>
          </Box>
         </Box>}
         {/* } */}
         </Box>}
         </Box>
         {(source === "SC" && !isSidebarOpen && !isMobile) &&(
          <>
          <Box
            sx={{
              display: 'flex', // Ensure the child boxes are aligned horizontally
              gap: '12px', // Add some space between the two boxes
            }}
          >
            <Box
              className={styles.filterContainer}
              onClick={handleSidebarToggle}
              sx={{
                // opacity: isSidebarOpen ? '0' : '1',
                pointerEvents: isSidebarOpen ? 'none' : 'all',
                height: '43px',
              }}
            >
              <Box className={styles.filterContentWrapper}>
                <img src='https://members.performancegolf.com/wp-content/uploads/2025/12/filter-black-icon.svg' alt=''/>
                <Typography className={styles.filterText}>FILTER ({courseTypeCount})</Typography>
              </Box>
            </Box>
            </Box>
            </>
          )}
         {( !isMobile && source !== "SC" ) &&(
          <>
          <Box
            sx={{
              display: 'flex', //  boxes are aligned horizontally
              gap: '12px', 
            }}
          >
            <Box
              className={styles.filterContainer}
              onClick={handleSidebarToggle}
              sx={{
                // opacity: isSidebarOpen ? '0' : '1',
                pointerEvents: isSidebarOpen ? 'none' : 'all'
              }}
            >
              <Box className={styles.filterContentWrapper}>
                <img src='https://members.performancegolf.com/wp-content/uploads/2025/12/filter-black-icon.svg' alt=''/>
                <Typography className={styles.filterText}>FILTER ({courseTypeCount})</Typography>
              </Box>
            </Box>

            <Box
              sx={{
                borderLeft: source !== 'SC' ? '1px solid #7B726C' : "",
                height: '41px', 
              }}
            />

            <Box
            sx={{
              maxHeight: '43px',
              overflowX: 'auto',
              display: 'flex',
              flexDirection: 'row',
              gap: '12px',
              marginBottom:'10px'
            }}
            >
          {localFilterData
            .filter(filter => filter.filterType === "Course Type") // Only include "Course Type"
            .map(filter =>
            filter.data
                .filter(el => allowedCourseTypes.includes(el.category)) // Filter only allowed course types
                .map(el => {
                const isSelected = selectedFilters[filter.filterType]?.includes(el.category);
                return (
                  <Box
                    onClick={() => onFilterChange(filter.filterType, el.category, isSelected ? false : true)}
                    key={`${filter.filterType}-${el.category}`}
                    className={styles.filterBox}
                    sx={{
                      padding: '12px',
                      backgroundColor: isSelected ? '#FD3300' : 'transparent',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexGrow: 1,
                      }}
                    >
                      <Typography
                        sx={{ whiteSpace: 'nowrap', textTransform: 'uppercase', fontFamily: "'Repro Mono', sans-serif" }}
                        fontSize={16}
                        fontWeight={400}
                        color= {isSelected? "#fff" : "#444448"}
                        overflow= 'hidden'
                      >
                        {transformString(el.title)}
                      </Typography>
                      {isSelected && <img src={CLOSE_IMAGE_URL} style={{marginLeft:'8px'}} alt="Remove Filter" />}
                    </Box>  
                  </Box>
                );
              })
            )}
            </Box>
            </Box>
            </>
          )}
    </Box>
  )
}

export default TrainingHeader